import { FC } from 'react'
import ReactModal from 'react-modal'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducers } from '../../redux/reducers'
import classes from './ModalError.module.css'
import { resetError } from '../../redux/actions/error.action'

const ModalError: FC = () => {
  const dispatch = useDispatch()
  const errorReducer = useSelector((state: RootReducers) => state.errorReducer)

  const handleOk = () => {
    dispatch(resetError())
  }

  return (
    <ReactModal
      id="ERROR_MODAL"
      isOpen={errorReducer.isError}
      style={{
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(24, 48, 40, 0.9)'
        },
        content: {
          width: 450,
          height: 'max-content',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%,-50%)',
          padding: 40,
          borderRadius: 8
        }
      }}
      ariaHideApp={false}
    >
      <div className={classes.Title}>ไม่สามารถทำรายการได้ กรุณาติดต่อผู้ดูแลระบบเพื่อตรวจสอบ</div>
      <div className={classes.Desc}>{errorReducer.desc}</div>
      <button className={classes.Btn} onClick={handleOk}>
        ตกลง
      </button>
    </ReactModal>
  )
}

export default ModalError
